import React from 'react';
import classnames from 'classnames';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { Text } from '../text';
import styles from "./tooltip.module.css";
export const Tooltip = ({ label, text, id, className }) => {
    const classes = classnames(styles.tooltip, className);
    return (React.createElement(React.Fragment, null,
        React.createElement(ReactTooltip, { anchorSelect: `#${id}`, opacity: "1", className: classes },
            label && React.createElement("div", { className: styles.label }, label),
            typeof text === 'string' ? (React.createElement(Text, { variant: "paragraph-100", className: styles.text }, text)) : (React.createElement("div", { className: styles.text }, text)))));
};
//# sourceMappingURL=index.js.map